var _module_exports = "<div class=\"pr-response-count\">\n\t<span>{{ $ctrl.getResponseCount() }}</span>\n\t<span class='file-bar-label title-label' translate>RESPONSES</span>\n</div>";;
var path = '/client/components/toolbar/response-count/response-count.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;